import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AuthGuard, AuthComponent, GuestGuard, UserRegistrationComponent, ProfileComponent, ResetPasswordComponent, OtherUserComponent, ConversationComponent } from 'shared';
import { UserListComponent } from './user-list/user-list.component';

export const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'chat', component: ConversationComponent, canActivate: [AuthGuard]  },
  { path: 'chat/:id', component: ConversationComponent, canActivate: [AuthGuard]  },
  { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
  { path: 'user-list', component: UserListComponent, canActivate: [AuthGuard]},
  { path: 'other-user/:id', component: OtherUserComponent, canActivate: [AuthGuard] },
  { path: 'login', component: AuthComponent, canActivate: [GuestGuard] },
  { path: 'register', component: UserRegistrationComponent, canActivate: [GuestGuard] },
  { path: 'reset-password', component: ResetPasswordComponent},
  { path: 'other-user/:id', component: OtherUserComponent},
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
